// services/fontteService/base.ts - services/fontteService.ts split (sub-module base)

import { withRetry } from '../../utils/retryLogic';

import type {FontteResponse} from './types.js';
import { VPS_API_KEY } from './config.js';
import { VPS_API_URL } from './config.js';
import { normalizePhoneNumber } from './phone.js';


export async function sendWhatsAppMessage(
    phoneNumber: string,
    message: string,
    countryCode: string = '62',
    device?: string,
    customApiKey?: string
): Promise<FontteResponse> {
    const target = normalizePhoneNumber(phoneNumber, countryCode);

    if (!target || target.length < 8) {
        return { status: false, message: 'Format nomor telepon tidak valid', errorCode: 'INVALID_PHONE_NUMBER' };
    }

    // Backend /api/whatsapp/send WAJIB apiKey (token Fonnte nomor pengirim).
    // Brand tanpa token (mis. murni Baileys) akan 400 — jangan tembak request
    // yang pasti gagal ( console error 400 di halaman publik), kembalikan
    // error jelas agar pemanggil bisa skip diam-diam.
    if (!customApiKey) {
        return { status: false, message: 'Token pengirim WA belum dikonfigurasi untuk brand ini', errorCode: 'NO_SENDER_KEY' };
    }

    try {
        const response = await withRetry(() => fetch(`${VPS_API_URL}/api/whatsapp/send`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': VPS_API_KEY,
            },
            body: JSON.stringify({ phone: target, message, countryCode, device, apiKey: customApiKey }),
            signal: AbortSignal.timeout(10000),
        }), {
            maxRetries: 2,
            initialDelayMs: 1000,
            backoffMultiplier: 2,
            shouldRetry: (err) => {
                if (err instanceof TypeError) return true;
                return false;
            },
        });
        const text = await response.text();
        let data;
        try { data = JSON.parse(text); } catch { data = null; }

        if (!response.ok || (data && !data.status)) {
            return {
                status: false,
                message: data?.message || text || 'Gagal mengirim pesan',
                errorCode: 'VPS_API_ERROR',
                details: { status: response.status, response: data || text }
            };
        }
        return data || { status: true, message: 'OK' };
    } catch (error: any) {
        return {
            status: false,
            message: error.message || 'VPS API connection failed',
            errorCode: 'VPS_API_NETWORK_ERROR'
        };
    }
}
